import React from "react";

type MetricsViewProps = {
  // TODO: add props here
};

const MetricsView: React.FC<MetricsViewProps> = (props) => {
  return (
    <div>
      <div>
        <h1 className="text-3xl font-bold text-center text-primary pt-3">
          Metrics
        </h1>
      </div>
    </div>
  );
};

export default MetricsView;
